import { GroupBase, MultiValueProps } from "react-select";
import { Tag, TagClose } from "../../../../../Tag";

export function MultiValue<Option, IsMulti extends boolean, Group extends GroupBase<Option>>
({ className, children, innerProps, removeProps, ...props }: MultiValueProps<Option, IsMulti, Group>) {
  return (
    <Tag
      {...innerProps}
      tagSize="md"
      ref={innerProps?.ref as any}
      endAdornment={
        <TagClose
          {...removeProps as any}
          tagSize="md"
        />
      }
    >
      {children}
    </Tag>
  );
}